// @ts-nocheck
import {
    AddStockedItemsFilter,
    chain,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { addToChainAfter, HandlerWithResult } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, AddStockedItemsFilter, props => {
    if (props.parameter.inStockRealTime !== undefined) {
        props.result.inStockRealTime = props.parameter.inStockRealTime;
    }
});
